import { CSSProperties, useState } from 'react';
import classNames from 'classnames';
interface CoverUploadProps {
  src?: string;
  className?: string;
  gradient?: CSSProperties;
}

export const CoverUpload = ({ src, gradient, className }: CoverUploadProps) => {
  const [image] = useState<File | null>(null);

  return (
    <>
      <div
        className={classNames(
          className,
          'bg-holder rounded-top hover-actions-trigger position-absolute'
        )}
        style={{
          backgroundImage: `${gradient ? gradient + ',' : ''}url(${
            image ? URL.createObjectURL(image) : src
          })`
        }}
      ></div>
    </>
  );
};

export const CoverUploadSquare = ({
  src,
  gradient,
  className
}: CoverUploadProps) => {
  const [image] = useState<File | null>(null);

  return (
    <>
      <div
        className={classNames(
          className,
          'bg-holder hover-actions-trigger position-absolute'
        )}
        style={{
          backgroundImage: `${gradient ? gradient + ',' : ''}url(${
            image ? URL.createObjectURL(image) : src
          })`
        }}
      ></div>
    </>
  );
};

export default CoverUpload;
